import { faArrowRight, faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Options } from 'component-library/lib/esm/models/ComponentModels';
import { useEffect, useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';

interface DropDownProps {
  value?: string;
  firstData: Options[];
  secondData: Options[];
  placeholder: string;
  onValueChosen: (id?: string) => void;
}

export default function SelectBoatMakeDropdown(props: DropDownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState(props.firstData);
  const [isOriginalData, setIsOriginalData] = useState(true);
  const [selectedValue, setSelectedValue] = useState(props.value ? props.value : undefined);
  const [searchValue, setSearchValue] = useState('');
  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  useEffect(() => {
    setData(isOriginalData ? props.firstData : props.secondData);
  }, [props.firstData, props.secondData, isOriginalData]);

  const ref = useDetectClickOutside({
    onTriggered: () => {
      setIsOpen(false);
      setSearchValue('');
    },
  });

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    if (isOpen) setSearchValue('');
  };

  const toggleData = () => {
    if (isOriginalData) {
      setData(props.secondData);
    } else {
      setData(props.firstData);
    }
    setIsOriginalData(!isOriginalData);
    setSearchValue('');
  };

  const handleValueSelect = (value?: string) => {
    setSelectedValue(value);
    setSearchValue('');
    toggleDropdown();
  };

  const filteredData = data.filter((opt) => opt.value?.toLowerCase().includes(searchValue.toLowerCase()));

  return (
    <div ref={ref}>
      <div className='relative'>
        <button
          type='button'
          className='w-full h-10 px-4 py-2 bg-gray-3 prose-paragraphSmaller outline-0 gap-2 whitespace-nowrap overflow-hidden flex justify-between items-center'
          onClick={toggleDropdown}
        >
          <span className={`${!selectedValue && 'text-gray-40'}`}>
            {selectedValue ? selectedValue : props.placeholder}
          </span>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </button>
        {isOpen && (
          <div className='absolute bg-white py-1 mt-2 m-0 w-full z-10 shadow-dropdown border border-gray-10 max-h-[260px] overflow-auto'>
            <div className='px-2 pt-2 pb-1 sticky top-0 bg-white'>
              <input
                value={searchValue}
                onChange={(event) => setSearchValue(event.target.value)}
                placeholder='Search brand / make...'
                className='w-full bg-gray-3 prose-paragraphSmaller outline-0 px-3 h-9'
              />
            </div>
            <ul>
              {filteredData.length > 0 ? (
                filteredData.map((opt, index) => (
                  <li
                    className='py-2 px-4 flex w-full text-gray-100 prose-paragraphSmaller hover:bg-gray-5 cursor-pointer'
                    key={opt.id ?? index}
                    onClick={() => {
                      props.onValueChosen && props.onValueChosen(opt.id);
                      handleValueSelect(opt.value);
                    }}
                  >
                    {opt.value}
                  </li>
                ))
              ) : (
                <li className='py-2 px-4 flex w-full prose-paragraphSmaller italic text-gray-40 cursor-default'>
                  Nothing here
                </li>
              )}
              <li
                onClick={toggleData}
                className='py-2 px-4 flex w-full text-gray-100 prose-paragraphSmaller hover:bg-gray-5 cursor-pointer'
              >
                <button type='button'>
                  <span className='font-bold mr-2'>
                    Select from {isOriginalData ? 'all' : 'own'} brands
                  </span>
                  <FontAwesomeIcon icon={faArrowRight} />
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
